"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const SearchWithCriteria_1 = __importDefault(require("@Components/Search/SearchWithCriteria"));
const contexts_1 = require("@App/contexts");
const catalog_search_store_1 = require("@App/stores/search/catalog-search-store");
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const WorkResultsTable_1 = __importDefault(require("@Components/WorkItemV2/WorkResultsTable"));
const CatalogCompactWorkItem_1 = __importDefault(require("@Components/WorkItemV2/Catalog/CatalogCompactWorkItem"));
const OverclaimExtendedWorkItem_1 = __importDefault(require("@Components/WorkItemV2/OverclaimAndDisputes/OverclaimExtendedWorkItem"));
const overclaim_search_store_1 = require("@App/stores/overclaim/overclaim-search-store");
const OverclaimHeader_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch/OverclaimHeader"));
const Sidebar_1 = require("@Components/Sidebars/Sidebar");
const DownloadSidebar_1 = __importDefault(require("@Components/Sidebars/DownloadSidebar"));
const sidebar_download_type_1 = require("@App/enum/sidebar-download-type");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const OverclaimExportButton_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch/OverclaimExportButton"));
const export_type_1 = require("@App/enum/export-type");
const overclaim_search_filter_definition_1 = require("@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch/overclaim-search-filter-definition");
const OverclaimBulkRelinquishmentControl_1 = __importDefault(require("@Components/WorkItemV2/OverclaimAndDisputes/OverclaimBulkRelinquishmentControl"));
const mobx_react_1 = require("mobx-react");
const BulkRelinquishmentLeavePageConfirmationPopup_1 = __importDefault(require("@Components/Popups/ConfirmationPopup/BulkRelinquishmentLeavePageConfirmationPopup"));
const react_sdk_1 = require("@openfeature/react-sdk");
const RightsholderOverclaimSearch = () => {
    const { rightsholderStore, exportStore, overclaimSearchStore, overclaimViewStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { value: showBulkRelinquishment } = (0, react_sdk_1.useFlag)('overclaim-bulk-relinquishment', false);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [exportSidebarIsOpen, setExportSidebarIsOpen] = (0, react_1.useState)(false);
    const [overclaimCriteriaStore, setOverclaimCriteriaStore] = (0, react_1.useState)(overclaimSearchStore.createOverclaimCriteriaStore());
    const [overclaimFiltercount, setOverclaimFiltercount] = (0, react_1.useState)();
    // States to manage the attempted leave popup, for when there are selected works for bulk action and a user changes pagination
    const [showAttemptedLeavePopup, setShowAttemptedLeavePopup] = (0, react_1.useState)(false);
    const [pendingPagination, setPendingPagination] = (0, react_1.useState)();
    const closeExportSidebar = () => {
        setExportSidebarIsOpen(false);
    };
    const reset = () => __awaiter(void 0, void 0, void 0, function* () {
        setOverclaimCriteriaStore(overclaimSearchStore.createOverclaimCriteriaStore());
        overclaimSearchStore.destroyOverclaimCriteria();
        yield runSearch();
    });
    const runSearch = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (callBackPagination = catalog_search_store_1.defaultCatalogPagination) {
        if (overclaimSearchStore.overclaimsSelectedForBulkAction.size > 0) {
            setShowAttemptedLeavePopup(true);
            setPendingPagination(callBackPagination);
            return;
        }
        setLoading(true);
        yield overclaimSearchStore.searchForWorks(callBackPagination);
        setLoading(false);
    });
    const getStatusesCounts = () => __awaiter(void 0, void 0, void 0, function* () {
        yield overclaimSearchStore.setupOverclaimStatusCounts();
        setOverclaimFiltercount(overclaimSearchStore.overclaimStatusCounts);
    });
    const runSearchWithNewCriteria = (searchCriteria, filters) => __awaiter(void 0, void 0, void 0, function* () {
        overclaimSearchStore.setOverclaimSelectionSearchQuery(searchCriteria);
        overclaimSearchStore.setCurrentSearchFilters(filters);
        yield runSearch();
    });
    const onChangeLimit = (newLimit) => __awaiter(void 0, void 0, void 0, function* () {
        yield runSearch(overclaimSearchStore.changeSearchResultsLimit(newLimit));
    });
    (0, react_1.useEffect)(() => {
        overclaimViewStore.destroyOverclaimViewItem();
        getStatusesCounts().finally();
        if (overclaimSearchStore.isDefaultPagination) {
            runSearch({
                limit: overclaimSearchStore.pagination.limit,
                page: overclaimSearchStore.pagination.page,
            }).finally();
        }
        exportStore.setExportType(export_type_1.ExportType.OVERCLAIMS);
        exportStore.loadExportFormats().then();
    }, []);
    const onConfirmLeave = () => __awaiter(void 0, void 0, void 0, function* () {
        overclaimSearchStore.resetOverclaimSelectionForBulkAction();
        setShowAttemptedLeavePopup(false);
        yield runSearch(pendingPagination);
        setPendingPagination(undefined);
    });
    return (react_1.default.createElement("div", { className: 'rightsholder-overclaim-wrapper' },
        react_1.default.createElement("div", { className: 'global-container' },
            react_1.default.createElement(OverclaimHeader_1.default, { statusCounts: overclaimFiltercount }),
            react_1.default.createElement("section", { className: 'overclaim-search-result-section' },
                react_1.default.createElement(ModalPortal_1.default, { isOpen: showAttemptedLeavePopup },
                    react_1.default.createElement(BulkRelinquishmentLeavePageConfirmationPopup_1.default, { onClose: () => setShowAttemptedLeavePopup(false), onConfirm: onConfirmLeave })),
                react_1.default.createElement(SearchWithCriteria_1.default, { searchCriteriaStore: overclaimCriteriaStore, handleSearch: runSearchWithNewCriteria, disableSearchButtons: loading || overclaimSearchStore.isOverclaimBulkActionStarted, resetSearchFn: reset, defaultFilterValues: overclaim_search_store_1.OVERCLAIM_SEARCH_DEFAULT_FILTERS, filterFieldCollections: overclaim_search_filter_definition_1.OverclaimSearchFilters, extraButtons: [
                        react_1.default.createElement(OverclaimExportButton_1.default, { key: 'export-button', overclaimSearchStore: overclaimSearchStore, loading: loading, setSidebarIsOpen: setExportSidebarIsOpen }),
                    ] })),
            loading ? (react_1.default.createElement(PointPreloader_1.default, null)) : (react_1.default.createElement(WorkResultsTable_1.default, { works: overclaimSearchStore.worksRightsHolder, claimedShares: rightsholderStore.rightsholderClaimedShares, paginationInfo: overclaimSearchStore.worksRightsHolderPaginationInfo, limit: overclaimSearchStore.limit, onChangePage: runSearch, onChangeLimit: onChangeLimit, compactWorkComponentType: CatalogCompactWorkItem_1.default, extendedWorkComponentType: OverclaimExtendedWorkItem_1.default, compact: false, showCompactToggle: false, bulkActionControlSection: showBulkRelinquishment ? react_1.default.createElement(OverclaimBulkRelinquishmentControl_1.default, null) : undefined }))),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: exportSidebarIsOpen, onClose: closeExportSidebar },
            react_1.default.createElement(Sidebar_1.Sidebar, { onClose: closeExportSidebar },
                react_1.default.createElement(DownloadSidebar_1.default, { closeSidebar: closeExportSidebar, sidebarDownloadType: sidebar_download_type_1.SidebarDownloadType.OverclaimExport })))));
};
exports.default = (0, mobx_react_1.observer)(RightsholderOverclaimSearch);
